import type { AppointmentBookingDraftV1 } from "@/app/booking/core/appointmentBookingDraft";
import { buildLocationProfilePath } from "@/app/locations/routes";
import { buildSpecialistProfilePath } from "@/app/specialists/routes";

/**
 * Route-agnostic import boundary for shared booking consumers. The current
 * implementation remains beside the Specialist compatibility fallback until
 * that fallback is retired, while callers no longer need a Specialist-named
 * dependency to support both entry points.
 */
export {
  buildAppointmentCurrentAssignmentReturnProjection,
  buildAppointmentReturnHref,
  type AppointmentCurrentAssignmentReturnProjection,
} from "./specialistAppointmentReturnHref";

/**
 * Resolves the canonical public document that owns an appointment journey.
 * Completion and waitlist Close actions use this after their descendant state
 * has been removed; they must never send a Location-origin customer home or
 * through a Specialist route that was not their entry point.
 */
export function buildAppointmentEntryProfileHref(
  entryPoint: AppointmentBookingDraftV1["entryPoint"],
) {
  return entryPoint.kind === "specialist-services"
    ? buildSpecialistProfilePath({
        locationId: entryPoint.locationId,
        userLocationId: entryPoint.userLocationId,
      })
    : buildLocationProfilePath(entryPoint.locationId);
}
